<template>
    <div class="accordion-item">
        <h3 class="accordion-header" id="standard-header">
            <button class="accordion-button d-flex" type="button" data-bs-toggle="collapse" data-bs-target="#standard-collapse" aria-expanded="true" aria-controls="standard-collapse">
                <span class="flex-grow-1">Standards</span>
                <span class="me-2 badge rounded-pill bg-primary">{{ selected.length }}</span>
            </button>
        </h3>
        <div id="standard-collapse" class="accordion-collapse collapse" aria-labelledby="standard-header" data-bs-parent="#accordion-filter-options" ref="accbody">
            <div class="accordion-body">
                <div class="list-group list-group-selectable">
                    <div v-for="st in standards" class="list-group-item" @click="select(st)" :active="selected.includes(st.id)">
                        <h6 class="text-primary">
                            {{ st.code }}
                            <span v-if="st.subcode">({{ st.subcode }})</span>
                            &nbsp;{{ st.a_name }}
                            <span class="text-muted small">{{ st.a_state }}-{{ st.a_year }}</span>
                        </h6>
                        <div style="white-space: pre-wrap;">{{ st.content }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueCookies from 'vue-cookies';

export default {
    components: { VueCookies },
    
    data() {
        return {
            selected: [],
            standards: []
        }
    },

    mounted() {
        this.$refs.accbody.addEventListener('show.bs.collapse', event => {
            this.load();
        });

        if (VueCookies.isKey('st')) {
            this.selected = VueCookies.get('st');
        }
    },

    methods: {
        load: function() {
            const data = this.$parent.poll();

            if (!data.strands.length || !data.areas.length) {
                console.debug('Not enough information to find standards');
                return;
            }

            this.$parent.isLoading = true;

            axios
                .get('/api/standards', {params: data})
                .then(response => {
                    this.standards = response.data;
                })
                .catch(error => {
                    console.error(error);
                })
                .finally(() => {
                    this.$parent.isLoading = false;
                });
        },

        select: function(standard) {
            if (this.selected.includes(standard.id)) {
                this.selected = this.selected.filter(st => st != standard.id);
            } else {
                if (this.selected.length >= 8) {
                    console.log('The maximum number of selected standards is set to 8');
                } else {
                    this.selected.push(standard.id);
                }
            }

            this.store();
            this.$parent.poll();
        },

        store: function() {
            VueCookies.set('st', this.selected, Infinity);
        },

        clear: function() {
            this.selected = [];
            this.store();
        }
    }


}
</script>